export default __webpack_public_path__ + "cb9b7f4770f1353a8cc13154d2d8cd6e.webp";